// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vtzV","type":"styles_type__1BayK","choices":"styles_choices__19hhb"};